import { ActionType } from 'typesafe-actions';

import { IS_ESIA, LOGIN } from 'CorePackage/MainModule/constants/localStorageNames';

import * as actions from '../actions/authActions';
import { AuthActionsEnum } from '../enums/AuthActionsEnum';
import { IAuthState } from '../interfaces/IAuthState';

export type AuthAction = ActionType<typeof actions>;

const initialState: IAuthState = {
  user: undefined,
  stage: 'login',
  isLoggedOut: false,
};

export function authReducer(state: IAuthState = initialState, action: AuthAction): IAuthState {
  switch (action.type) {
    case AuthActionsEnum.SET_USER: {
      return {
        ...state,
        user: action.payload.user,
      };
    }
    case AuthActionsEnum.CLEAR_USER: {
      sessionStorage.removeItem(IS_ESIA);
      sessionStorage.removeItem(LOGIN);

      return {
        ...state,
        user: undefined,
      };
    }
    case AuthActionsEnum.AUTH_SET_ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
      };
    }
    case AuthActionsEnum.AUTH_SET_STAGE: {
      const { stage } = action.payload;

      return {
        ...state,
        stage,
      };
    }
    case AuthActionsEnum.AUTH_SET_ORGANIZATIONS: {
      const { organizations } = action.payload;

      return {
        ...state,
        organizations,
      };
    }
    case AuthActionsEnum.AUTH_SET_IS_LOGGED_OUT: {
      const { isLoggedOut } = action.payload;

      return {
        ...state,
        isLoggedOut,
      };
    }
    default:
      return state;
  }
}
